// extracted by mini-css-extract-plugin
module.exports = {"signatureButtonContainer":"VisitorAgreementStep_signatureButtonContainer__1TcbM","signature":"VisitorAgreementStep_signature__UWvJl"};